import * as React from "react";
import { Input } from "@forge/common";
import { useCallback } from "react";

interface GoToPageProps {
  pageCount: number;
  handleGoToPage: (page: number) => void;
}

const GoToPage = (props: GoToPageProps) => {
  const { pageCount, handleGoToPage } = props;
  /**
   *
   * @param event - Keyboard event
   * On pressing enter key in the input field, the page should be navigated to the entered page number
   */
  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>, pageCount: number) => {
      const page = parseInt(event.currentTarget.value, 10) - 1;
      if (event.key === "Enter" && page >= 0 && page < pageCount) {
        handleGoToPage(page);
      }
    },
    []
  );
  return (
    <>
      <label>Go to page</label>
      <Input
        id={"goToPage"}
        type={"number"}
        style={{ width: "4rem" }}
        onKeyDown={(event) => handleKeyDown(event, pageCount)}
        data-testid={"goToPage"}
      />
    </>
  );
};

export default GoToPage;
